module.exports = new __parcel__URL__("epa-ch4emission-yeargrid-v2express.thumbnails.petroleum.refining.annual.a08464d9.png").toString();